export const TASK_STATUS = [
    {
        value: "not_started",
        label: "Not Started"
    },
    {
        value: "pending",
        label: "Pending"
    },
    {
        value: "in_progress",
        label: "In Progress"
    },
    {
        value: "done",
        label: "Done"
    },
    {
        value: "delayed",
        label: "Delayed"
    },
    {
        value: "blocked",
        label: "Blocked"
    }
];
